import { faTasks } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from '@mui/material'
import { ActionIconButton } from 'components/Layout/ActionIconButton'
import { newProjectActions } from 'features/BillOfMaterials/store/projectReducer'
import { ProjectEditableStateSelector } from 'features/BillOfMaterials/store/selectors/ProjectEditableStateSelector'
import { useBomItemDetailsDialog } from 'features/BomItemDetailsDialog/useBomItemDetailsDialog'
import { useDialogManager } from 'features/DialogManager/useDialogManager'
import { BomItemType } from 'model/Project/BoMItemRow'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from 'store/configureStore'
import { WorkingStepMultipleItemsDialogProps } from './WorkingStepMultipleItemsDialog'

export function AddWorkingStepButton(props: {
  bomItemPointers: BomItemPointer[]
}) {
  const openBomItemDetailsDialog = useBomItemDetailsDialog()

  const { openDialog } = useDialogManager()

  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  // const appDocumentEventsDispatcher = useAppDocumentEventsDispatcher()

  const projectIsEditable = useAppSelector(ProjectEditableStateSelector)

  const setWorkingStepsDialogOpen = useCallback(() => {
    if (
      !props.bomItemPointers.length ||
      props.bomItemPointers[0].type === BomItemType.partInstance
    ) {
      return
    }

    if (props.bomItemPointers.length === 1) {
      dispatch(newProjectActions.setBomItemInSearch(props.bomItemPointers?.[0]))
      openBomItemDetailsDialog('workingsteps', {
        bomItemPointer: props.bomItemPointers[0],
        workingStep: undefined,
      })
    } else {
      openDialog('WorkingStepMultipleItemsDialog', {
        bomItemPointers: props.bomItemPointers,
      } as WorkingStepMultipleItemsDialogProps)
    }
  }, [dispatch, openBomItemDetailsDialog, openDialog, props.bomItemPointers])

  if (!projectIsEditable) {
    return null
  }

  return (
    <>
      <Tooltip
        title={t('project:working-steps-add-button')}
        arrow
        placement="top"
      >
        <ActionIconButton
          size="small"
          onClick={() => {
            setWorkingStepsDialogOpen()
          }}
        >
          <FontAwesomeIcon icon={faTasks} />
        </ActionIconButton>
      </Tooltip>
    </>
  )
}
